import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  OccConfig,
  UrlModule
} from '@spartacus/core';
import { IconModule, SpinnerModule } from '@spartacus/storefront';
import { DeliveryNotesOverviewTableDefaultComponent } from './components/delivery-notes-overview/delivery-notes-overview-table-default/delivery-notes-overview-table-default.component';
import { DeliveryNotesOverviewComponent } from './components/delivery-notes-overview/delivery-notes-overview.component';
import { DeliveryNotesDetailComponent } from './components/delivery-notes-detail/delivery-notes-detail.component';
import { DeliveryNotesAdapter } from './delivery-notes.adapter';
import { DeliveryNotesEffects } from './store/delivery-notes.effects';
import {
  deliveryNotesFeatureKey,
  deliveryNoteReducer,
  marketplaceDeliveryNotesFeatureKey
} from './store/delivery-notes.reducer';
import { UigDeliveryNotesGuard } from './uig-delivery-notes.guard';
import { MarketplaceDeliveryNotesDetailComponent } from './components/marketplace-delivery-notes-detail/marketplace-delivery-notes-detail.component';
import { MarketplaceDeliveryNotesOverviewComponent } from './components/marketplace-delivery-notes-overview/marketplace-delivery-notes-overview.component';

@NgModule({
  declarations: [
    DeliveryNotesOverviewComponent,
    DeliveryNotesOverviewTableDefaultComponent,
    DeliveryNotesDetailComponent,
    MarketplaceDeliveryNotesDetailComponent,
    MarketplaceDeliveryNotesOverviewComponent  
  ],
  imports: [
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            deliveryNotes: '/myrio/deliveryNotes',
            deliveryNotesDownload: '/myrio/deliveryNotes/download',
            deliveryNotesPdf: '/myrio/deliveryNotes/pdf',
            deliveryNotesDetail: '/myrio/deliveryNotes/view/${deliveryId}',
            deliveryNotesDetailDownload: '/myrio/deliveryNotes/view/${deliveryId}/download',
            marketplaceDeliveryNotes: '/myrio/deliveryNotes/marketplace',
            marketplaceDeliveryNotesDetail: '/myrio/deliveryNotes/marketplace/view/${deliveryId}',
          },
        },
      },
    } as OccConfig),
    ConfigModule.withConfig({
      cmsComponents: {
        DeliveryNotesComponent: {
          component: DeliveryNotesOverviewComponent,
          guards :[AuthGuard ,UigDeliveryNotesGuard]
         },
         DeliveryNotesDetailComponent: {
           component: DeliveryNotesDetailComponent,
           guards :[AuthGuard ,UigDeliveryNotesGuard]
         },
         MarketplaceDeliveryNotesComponent: {
          component: MarketplaceDeliveryNotesOverviewComponent,
          guards :[AuthGuard ,UigDeliveryNotesGuard]
         },
         MarketplaceDeliveryNotesDetailComponent: {
           component: MarketplaceDeliveryNotesDetailComponent,
           guards :[AuthGuard ,UigDeliveryNotesGuard]
         }
      }
    } as CmsConfig),
    StoreModule.forFeature(
      deliveryNotesFeatureKey,
      deliveryNoteReducer
    ),
    StoreModule.forFeature(
      marketplaceDeliveryNotesFeatureKey,
      deliveryNoteReducer
    ),
    EffectsModule.forFeature([DeliveryNotesEffects]),
    I18nModule,
    RouterModule,
    UrlModule,
    CommonModule,
    NgSelectModule,
    FormsModule,
    SpinnerModule,
    IconModule
  ],
  providers: [
    {
      provide: DeliveryNotesAdapter,
      useClass: DeliveryNotesAdapter,
    },
    DatePipe,
  ],
})
export class DeliveryNotesModule {}
